import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "ml-3" }

import { AlertType, IAlert } from "@/types/alert";
import {
  XCircleIcon,
  ExclamationIcon,
  CheckCircleIcon,
} from "@heroicons/vue/solid";


interface Props {
  type: AlertType;
  message: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    message: null
  },
  setup(__props: any) {

const props = __props as {
  type: AlertType;
  message: string;
}



const errorAlert: IAlert = {
  bgColor: "bg-red-50",
  titleFontColor: "text-red-800",
  title: "Error",
  description: props.message,
  descriptionFontColor: "text-red-700",
  icon: XCircleIcon,
  iconColor: "text-red-400",
};

const warningAlert: IAlert = {
  bgColor: "bg-yellow-50",
  titleFontColor: "text-yellow-800",
  title: "Atencion",
  description: props.message,
  descriptionFontColor: "text-yellow-700",
  icon: ExclamationIcon,
  iconColor: "text-yellow-400",
};

const successAlert: IAlert = {
  bgColor: "bg-green-50",
  titleFontColor: "text-green-800",
  title: "Error",
  description: props.message,
  descriptionFontColor: "text-green-700",
  icon: CheckCircleIcon,
  iconColor: "text-grenn-400",
};

const completeAlert: IAlert =
  {
    error: errorAlert,
    warning: warningAlert,
    success: successAlert,
  }[props.type] ?? successAlert;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-md p-4", _unref(completeAlert).bgColor])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(completeAlert).icon), {
          class: _normalizeClass(["h-5 w-5", _unref(completeAlert).iconColor]),
          "aria-hidden": "true"
        }, null, 8, ["class"]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", {
          class: _normalizeClass(["text-sm font-medium", _unref(completeAlert).titleFontColor])
        }, _toDisplayString(_unref(completeAlert).title), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["mt-2 text-sm", _unref(completeAlert).descriptionFontColor])
        }, [
          _createElementVNode("p", null, _toDisplayString(_unref(completeAlert).description), 1)
        ], 2)
      ])
    ])
  ], 2))
}
}

})